import getConfig from "next/config";
import { getCountryCode } from "redux/selectors/location";
import { useSelector } from "react-redux";

const {
  publicRuntimeConfig: { leaflyDomain, leaflyCaDomain },
} = getConfig();

export const getDomainFromContext = (countryCode: string) =>
  countryCode === "CA" ? leaflyCaDomain : leaflyDomain;

const useDomain = () => getDomainFromContext(useSelector(getCountryCode));

export default useDomain;
